import React, {} from 'react'

interface Prop{
	title:string;
}

export const AppFormBlockTitle = (props: Prop) =>{
	return (
		<div className='app-form-block-title'>
			<div className="app-form-block-title-icon"></div>
			<div className="app-form-block-title-text">{props.title}</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppFormBlockTitle.tsx